module.exports = __webpack_public_path__ + "img/dynamic-51.28a93e41.png";